import {
  HeaderTableCell,
  NoWrapTableCell,
  SortableHeaderCell,
} from "../../../common/components/tables/cells"
import {
  ConciergeDialCountCell,
  ConciergeLastDialedCell,
  ConciergeLastDispositionCell,
} from "./ConciergeCallStatsCells"
import { LAST_DIAL_DATE_FIELD_LABEL } from "./lastDialDateFilter"

export function ConciergeCallStatsHeaderCells({
  sortColumn,
  sortDirection,
  onSortColumnChanged,
}) {
  return (
    <>
      <SortableHeaderCell
        HeaderCellComponent={HeaderTableCell}
        columnName="concierge_dial_count"
        label="Dials"
        sortColumn={sortColumn}
        sortDirection={sortDirection}
        onClick={onSortColumnChanged}
        title="Times this lead was dialed"
      />
      <SortableHeaderCell
        HeaderCellComponent={HeaderTableCell}
        columnName="concierge_last_dialed_at"
        label={LAST_DIAL_DATE_FIELD_LABEL}
        sortColumn={sortColumn}
        sortDirection={sortDirection}
        onClick={onSortColumnChanged}
        title="Last time this lead was called"
      />
      <HeaderTableCell title="Disposition of the most recent call">
        Last Disposition
      </HeaderTableCell>
    </>
  )
}

export function ConciergeCallStatsRowCells({ lead }) {
  return (
    <>
      <ConciergeDialCountCell lead={lead} />
      <ConciergeLastDialedCell lead={lead} />
      <ConciergeLastDispositionCell lead={lead} />
    </>
  )
}

export function ConciergeCallStatsLoadingCells() {
  return (
    <>
      <NoWrapTableCell />
      <NoWrapTableCell />
      <NoWrapTableCell />
    </>
  )
}

export const CONCIERGE_CALL_STATS_COLUMN_COUNT = 3
